import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getResponseGuideUrlOfSelectedTicket } from '../../../extractFromState';
import { NoMatchSection, DescriptionHeader, Heading, SubHeading, NoMatchInfo } from './MWNoMatch.styles';

export class MWNoMatch extends Component {
  render() {
    return (
      <NoMatchSection>
        <DescriptionHeader>Sorry you couldn't find a macro for this inquiry.</DescriptionHeader>
        <SubHeading>Below is a list of alternative ways you can try to resolve this ticket.</SubHeading>
        <NoMatchInfo>
          <Heading>Company Info -&nbsp;</Heading>
          <span>This tab contains documents outlining a Partner's policies, procedures, and best practices.</span>
        </NoMatchInfo>
        <NoMatchInfo>
          <Heading>Search All -&nbsp;</Heading>
          <span>
            This tab allows you to search through canned responses, historical ticket responses, and other details that
            will make answering tickets easier.
          </span>
        </NoMatchInfo>
        <NoMatchInfo>
          <Heading>Search Orders -&nbsp;</Heading>
          <span>This tab will allow you to look up and, in some cases, modify order information for the customer.</span>
        </NoMatchInfo>
        {this.props.responseGuideUrl && (
          <NoMatchInfo>
            <Heading>Response Guide -&nbsp;</Heading>
            <span>
              This tab will ask you questions about the ticket you're looking at and provide you with a suggested
              response.
            </span>
          </NoMatchInfo>
        )}
        <NoMatchInfo>
          <Heading>Partner's Website -&nbsp;</Heading>
          <span>
            This information is usually available in the Company Info document. Take the time to look over the Partner's
            website for additional information and answers. Often, the answers are there... the customer just didn't
            look for them.
          </span>
        </NoMatchInfo>
        <NoMatchInfo>
          <Heading>Google, Other Search Engines -&nbsp;</Heading>
          <span>
            If you've exhausted all other resources, Google and other search engines can be extremely helpful. They're
            great at finding information and answers that might not be readily available elsewhere.
          </span>
        </NoMatchInfo>
        <NoMatchInfo>
          <Heading>Need help? -&nbsp;</Heading>
          <span>
            Still not finding an answer? Reach out to us using the live chat icon in the lower-left corner of your
            screen; we're always glad to assist. Please include the ticket number when reaching out.
          </span>
        </NoMatchInfo>
      </NoMatchSection>
    );
  }
}

const mapStateToProps = (state) => ({
  responseGuideUrl: getResponseGuideUrlOfSelectedTicket(state),
});

export default connect(mapStateToProps)(MWNoMatch);
